const API = {
    VER: 'v.0.0.1.0707 ©2020 iStay',
    URL: {
        REVIEW: 'https://api.onescape.io/istay/service/review'
    },
    PARAMS: {},
    LANG: {
        BROWSER: '',
        USER: ''
    }
}

export default API;